import { applyFilters } from "helpers/filterCars"
import { useContext, useEffect, useState } from "react"
import { FilterContext } from "scenes/RentingScene/FilterContext"
import { RentingContext } from "scenes/RentingScene/RentingContext"

export default function useFilteredOptions(field, initialValue) {
  if (!field || !initialValue) throw new Error("Missing parameters")

  const { allCars } = useContext(RentingContext)
  const filter = useContext(FilterContext)
  const [options, setOptions] = useState(initialValue)

  useEffect(() => {
    const hasResults = option =>
      applyFilters(allCars, {
        ...filter,
        [field]: option.value
      }).length > 0

    setOptions(options.map(option => ({ ...option, disabled: !hasResults(option) })))
  }, [filter])

  /*
  useEffect(() => {
    castArray(options).forEach(option => {
      if (option.disabled && castArray(filter[field]).includes(option.value)) {
        // This option is selected but does nothing because of other filters
      }
    })
  }, [options])
  */

  return options
}
